import { ethers } from 'ethers'
import { BigNumber } from '@ethersproject/bignumber'

export function formatBigNumber(n: BigNumber, decimals: number, roundTo = 3): string {
  const str = ethers.utils.formatUnits(n, decimals.toString())
  if (!str.includes('.')) {
    return str
  }
  const sides = str.split('.')
  const start = sides[0]
  const end = sides[1]
  if (end.length < roundTo) {
    return str
  }
  return start + '.' + end.substring(0, roundTo)
}